export default "/images/marker-daily_rent.svg?d562d735061ca3809413841511c16075";